import type { Spring } from 'motion/react';

/** Micro-interactions: toggles, buttons, badges */
export const snappy: Spring = {
  stiffness: 500,
  damping: 30,
  mass: 1,
};

/** Layout shifts: panels expanding, rows appearing */
export const smooth: Spring = {
  stiffness: 300,
  damping: 30,
  mass: 1,
};
